module.exports = __webpack_public_path__ + "img/icon.73a39179.png";